var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.option)?_c('div',{staticClass:"option"},[_c('div',{staticClass:"option_body"},[_c('div',[_c('div',{staticStyle:{"display":"inline-block","margin-left":"auto","margin-right":"0px"}},[_c('h5',[_vm._v("Option : "+_vm._s(_vm.option.name))])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bde3c2b","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/Details/ValidationRequestable/Contract/Option.vue
// module id = 1921
// module chunks = 0